/* eslint-disable import/prefer-default-export */
import { getRequest, postRequest, putRequest } from "api/axiosClient";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/file-import`;

const createFileImport = (data: FormData) => postRequest(`${REACT_APP_CARGOBASE_BASE_URL}/create-file-import`, data);
const getFileImportHistory = (params?: Record<string, string>) => getRequest(`${baseURL}/history`, params);
const getFileImportDetails = (id: string) => getRequest(`${baseURL}/history/${id}`);
const getFileImportActions = (id: string) => getRequest(`${baseURL}/${id}/actions`);
const uploadRevisedFile = (id: string, data: FormData) => putRequest(`${baseURL}/revised-file-upload/${id}/`, data);
const getOffPlatformsListing = (params = {}) => getRequest(`${baseURL}/tracker`, params);

export { 
    createFileImport,
    getFileImportHistory,
    getFileImportDetails,
    getFileImportActions,
    uploadRevisedFile,
    getOffPlatformsListing };
